import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getVerkehrsstufeSelect } from 'src/app/project/shared/enums/verkehrsstufe';
import { getVerkehrszustandSelect } from 'src/app/project/shared/enums/verkehrszustand';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { SetMqControl } from 'src/app/project/shared/interfaces/set-mq-control';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';

@Component({
  selector: 'avs-set-mq-control',
  standalone: false,
  templateUrl: './set-mq-control.component.html',
  styleUrl: './set-mq-control.component.css'
})
export class SetMqControlComponent implements OnInit, OnChanges {

  @Input() dataEndChannels!: DataEndChannel[];
  @Input() selectedMqChannel?: DataEndChannel;

public state: boolean = false;

  public isVerkehrszustandDropdownOpen: boolean = false;
  public verkehrszustandSelect: SelectInput[] = getVerkehrszustandSelect();
  public selectedVerkehrszustand: SelectInput = { name: "Verkehrssituation" };

  public isTrafficDropdownOpen: boolean = false;
  public trafficSelect: SelectInput[] = getVerkehrsstufeSelect();
  public selectedTraffic: SelectInput = { name: "freier Verkehr", id: 1 }; /* null setzen? iwe vs */

  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.parseChannelState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedMqChannel'] && this.selectedMqChannel) {
      this.parseChannelState();
    }
  }

  private parseChannelState(): void {
    if (this.selectedMqChannel) {
      let doControl = this.selectedMqChannel.manualControl;
      if (doControl) {
        let parsedDoSettings = JSON.parse(doControl.settings);
        let parsedDo = parsedDoSettings.MQ;
        console.log('Parsed MQ State:', parsedDo);
        /* e.g. result 
         { VS: 5, Active: true, Traffic: 4 }
        */
      /*   this.state = parsedDoSettings.MQ.State; */
      this.selectedTraffic.id = parsedDo.Traffic;
      this.selectedTraffic.name = this.trafficSelect.find(t => t.id === parsedDo.Traffic)?.name || "freier Verkehr";
      this.selectedVerkehrszustand.id = parsedDo.VS;
      this.selectedVerkehrszustand.name = this.verkehrszustandSelect.find(vs => vs.id === parsedDo.VS)?.name || "Verkehrssituation";
      } else {
        console.log('No manual control found for this channel.');
      }
    }
  }
  public onVerkehrszustandItemClicked(item: SelectInput): void {
    this.isVerkehrszustandDropdownOpen = false;
    this.selectedVerkehrszustand.name = item.name
    this.selectedVerkehrszustand.id = item.id
  }

  public onVerkehrszustandDropdownClicked() {
    this.isVerkehrszustandDropdownOpen = !this.isVerkehrszustandDropdownOpen;
  }

  public onTrafficItemClicked(item: SelectInput): void {
    this.isTrafficDropdownOpen = false;
    this.selectedTraffic.name = item.name
    this.selectedTraffic.id = item.id
  }

  public onTrafficDropdownClicked() {
    this.isTrafficDropdownOpen = !this.isTrafficDropdownOpen;
  }

  public createMqControl(): void {
    let mqControl = {
      active: true,
      vs: this.selectedVerkehrszustand.id!,
      traffic: this.selectedTraffic.id!
    } as SetMqControl;
    this.dataEndChannelService.setMqManualControl(Number(this.selectedMqChannel?.id), mqControl).subscribe(resp => {
      this.alertService.alert('MQ Control wurde erstellt', AlertTypes.success);
    })
  }

  public setMqManualControlOff(): void {
    // Assuming you want to turn off the first channel
    let mqControl = {
      active: false,
      vs: 0,
      traffic: 0
    } as SetMqControl;
    this.dataEndChannelService.setMqManualControl(Number(this.selectedMqChannel?.id), mqControl).subscribe(resp => {
      this.alertService.alert('MQ Control wurde ausgeschaltet', AlertTypes.success);
    });
  }
}
